import { GetServerSideProps } from 'next';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React, { useMemo } from 'react';
import withUniverseVerification from 'src/HOCs/withUniverseVerification';
import PageMeta from 'src/components/organisms/page-meta';
import { PAGES_LOCALES } from 'src/constants/common.constants';
import { ExploreContentLayout } from 'src/features/common/explore/components/explore-content-layout';
import { ExploreHeader } from 'src/features/common/explore/components/explore-header';
import { CollectionsContainer } from 'src/features/common/explore/containers/collections-container';
import CollectionsTopFilterContainer from 'src/features/common/explore/containers/collections-top-filter-container';
import { fetchCollectionsThunk } from 'src/features/common/explore/ducks/collections/collections.thunk';
import { fetchUsersByIdsThunk } from 'src/features/common/user/ducks/user-list';
import { CollectionsPage as CollectionsPageOceanTemplate } from 'src/features/white-labels/ocean/collections/collections-page';
import { useGetUniverseTemplate } from 'src/hooks/use-get-universe-template';
import { PageLocaleI } from 'src/localisation/localisation.types';
import { wrapper } from 'src/store';
import { PageLayout } from 'src/ui/common/layouts/page-layout';

const CollectionsPage = () => {
    const { t } = useTranslation(['pages']);
    const { isOceanTemplate } = useGetUniverseTemplate();

    const locale: PageLocaleI = useMemo(
        () => ({
            title: t('collections.pageTitle', { ns: 'pages' }),
        }),
        [t]
    );

    if (isOceanTemplate) {
        return <CollectionsPageOceanTemplate />;
    }

    return (
        <>
            <PageMeta title={locale.title} />
            <PageLayout fullWidth>
                <ExploreHeader title={locale.title} withBorder />
                <ExploreContentLayout>
                    <ExploreContentLayout.Content>
                        <ExploreContentLayout.ExploreContent>
                            <CollectionsTopFilterContainer />
                            <CollectionsContainer />
                        </ExploreContentLayout.ExploreContent>
                    </ExploreContentLayout.Content>
                </ExploreContentLayout>
            </PageLayout>
        </>
    );
};

export const getServerSideProps: GetServerSideProps = wrapper.getServerSideProps((store) => async (ctx) => {
    // @ts-ignore
    const data = await store.dispatch(fetchCollectionsThunk());
    if (data?.payload?.collections?.length) {
        // @ts-ignore
        await store.dispatch(fetchUsersByIdsThunk(data.payload.collections.map((item) => item.ownerId)));
    }

    return {
        props: {
            ...(await serverSideTranslations(ctx.locale as string, PAGES_LOCALES)),
        },
    };
});

export default withUniverseVerification(CollectionsPage);